import { z } from 'zod'
import { DateTimeStringSchema } from './common'

/** クーポン利用回数制限の種別 */
export const CouponUsageLimitTypeSchema = z.enum(['ONCE', 'DAILY', 'UNLIMITED'])

/**
 * クーポンの利用制限・利用状況（消込前の可否判定用）。
 * 特典クーポン（prize.couponUsage）・スポットクーポン（coupons[].couponUsage）で共通。
 * ボタンの活性/非活性は必ず redeemableNow の単一フラグで判定し、
 * 個別フィールドから自前で可否を再計算しないこと（サーバとの判定ズレを防ぐため）。
 */
export const CouponUsageStateSchema = z.object({
  usageLimitType: CouponUsageLimitTypeSchema,
  /** 利用上限（通算）。null は無制限 */
  maxUseCount: z.number().nullable(),
  /** これまでの利用回数（couponConfig 単位の通算） */
  usedCount: z.number(),
  /** 本日（JST）すでに利用済みか */
  usedToday: z.boolean(),
  /** 現時点で消込可能か（総合判定） */
  redeemableNow: z.boolean(),
})

export const CouponDataSchema = z.object({
  id: z.number(),
  spotId: z.number().nullable(),
  name: z.string(),
  description: z.string().nullable(),
  code: z.string().nullable(),
  image: z.string().nullable(),
  status: z.number(),
  stampLinked: z.boolean().nullable(),
  termOfUse: z.boolean().nullable(),
  termOfUseValue: z.number().nullable(),
  termOfUseType: z.number().nullable(),
  startAt: DateTimeStringSchema.nullable(),
  endAt: DateTimeStringSchema.nullable(),
  expireAt: DateTimeStringSchema.nullable(),
  createdAt: DateTimeStringSchema.nullable(),
  updatedAt: DateTimeStringSchema.nullable(),
})

export const CouponGetResponseSchema = z.object({
  coupon: CouponDataSchema.nullable(),
})

export const CouponListResponseSchema = z.object({
  coupons: z.array(CouponDataSchema),
})

/** POST /api/v2/coupons/{id} レスポンス */
export const CouponRedeemResponseSchema = z.object({
  coupon: CouponDataSchema,
  usedAt: DateTimeStringSchema.nullable(),
  transactionId: z.number(),
})

export type CouponUsageLimitType = z.infer<typeof CouponUsageLimitTypeSchema>
export type CouponUsageState = z.infer<typeof CouponUsageStateSchema>
export type CouponData = z.infer<typeof CouponDataSchema>
export type CouponGetResponse = z.infer<typeof CouponGetResponseSchema>
export type CouponListResponse = z.infer<typeof CouponListResponseSchema>
export type CouponRedeemResponse = z.infer<typeof CouponRedeemResponseSchema>
